import { createElement, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'

import { ICreditCardInfos, IFormData, IProps, IViewProps } from './types'
import { HomeView } from './view'
import { ISelectCity, ISelectState, getCep, getCities, getState } from '../../shared/utils/handleAddress'
import { yupResolver } from '@hookform/resolvers/yup'
import cogoToast from 'cogo-toast'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import { isBefore } from 'date-fns'
import i18next from 'i18next'
import { useForm } from 'react-hook-form'
import useFormPersist from 'react-hook-form-persist'
import { useTypedSelector } from '../../shared/hooks/useTypedSelector'
import { ClientIpsInfoRequest } from '../../shared/interfaces/form'
import { ISubscription, Installments } from '../../shared/interfaces/subscriptions'
import { useVerifyCoupon, useCheckCupom, useSendSubscription, preRegister } from '../../shared/services/form.service'
import { paymentMethods } from '../../shared/utils/footer'
import cogoDefaultOptions from '../../shared/utils/toaster'
import routesEnum from '../Routes/enum'
import { formSchema } from './schema'
import { useCheckUser } from '../../shared/services/auth.service'
import { saveHubspotBehavioralProps } from '../../shared/utils/hubspot'
import Modal from 'react-modal'

//images
import banner from '../../assets/images/banner-desconto-ao-sair-cinza.png'

function HomeContainer(props: IProps) {

	const [isCupomValid, setIsCupomValid] = useState<boolean>(false);
	const [popupClosed, setPopupClosed] = useState<boolean>(false);
	const { userDetails } = props
	const [subscriptionSelected, setSubscriptionSelected] = useState<ISubscription | null>(null)

	const { search } = useLocation()

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [popupIsOpen, setPopupIsOpen] = useState(false);
	const [modalMessage, setModalMessage] = useState('[ Promoção Expirada ]');

	const urlParams = new URLSearchParams(window.location.search)
	let cupomFromQuery = urlParams.get('cupom')

	let verifyCouponResponse: any = null;

	function getUTMCookies() {
		sessionStorage.setItem('UTMCookies', search)
	}

	const [availableStates, setavailableStates] = useState<ISelectState[]>([])
	const [availableCities, setAvailableCities] = useState<ISelectCity[]>([])

	const navigate = useNavigate()
	const {
		allExistingActiveSubscriptions,
		locale: { isNational }
	} = useTypedSelector(['allExistingActiveSubscriptions', 'locale'])

	const {
		mutateAsync: mutateCupom,
		data: cupomCheckResponse,
		reset: resetCupom
	} = useCheckCupom()

	const {
		mutateAsync: mutateVerifyCoupon,
		data: couponVerifyResponse,
		reset: resetVerifyCoupon
	} = useVerifyCoupon()

	const {
		mutateAsync: mutateUser,
		data: userCheckResponse,
		reset: resetUser
	} = useCheckUser()

	const [showPopup, setShowPopup] = useState(false);

	useEffect(() => {
		verifyCoupon(cupomFromQuery);
	}, [cupomFromQuery])

	useEffect(() => {
		const handleMouseOut = (e: MouseEvent) => {
			const from = e.relatedTarget || (e as any).toElement;
			if (!from || (from as HTMLElement).nodeName === 'HTML') {
				let plano = urlParams.get('plano');
				let tipo = urlParams.get('tipo');
				let name = getValues('name');
				let email = getValues('email');

				let now = new Date();
				let end_at = now;
				if (verifyCouponResponse) {
					end_at = new Date(verifyCouponResponse.data.end_at);
				}

				if (plano == 'combo' && tipo == 'anual' && name && email && !popupClosed && (!cupomFromQuery || (cupomFromQuery && end_at < now))) {
					openPopup();
					setShowPopup(true);
					setPopupClosed(true);
				}
			}
		};

		document.addEventListener('mouseout', handleMouseOut);

		return () => {
			document.removeEventListener('mouseout', handleMouseOut);
		};
	}, [popupClosed]);


	useEffect(() => {
		const allPlans = Object.values(allExistingActiveSubscriptions)

		// ReactPixel.track('InitiateCheckout')
		let planFromQuery = urlParams.get('plano')
		let periodFromQuery = urlParams.get('tipo')

		let mrcProduct = planFromQuery === 'crusoe' ? 'crs' : planFromQuery === 'antagonista' ? 'oam' : 'a+ccbo'

		const subSelected = allPlans?.find(plan => {
			return plan.vindi_plan_interval_name.toLowerCase() === periodFromQuery?.toLowerCase() &&
				mrcProduct.includes(plan.mrc_product)
		}) ?? null

		setSubscriptionSelected(subSelected)
	}, [allExistingActiveSubscriptions])

	useEffect(getUTMCookies, [search])

	useEffect(() => {
		const exec = async () => {

			if (!subscriptionSelected?.vindi_plan_id || subscriptionSelected?.vindi_plan_id == 0) return

			const payment = getValues('payment')
			const installments = getValues('installments') !== undefined ? getValues('installments') : "1";

			cupomFromQuery && cupomFromQuery !== '' && await checkCupom(cupomFromQuery, payment, installments);
		}
		exec();
	}, [cupomFromQuery])

	const checkUser = async (email: string) => {
		if (!email) return
		const data = await mutateUser({ email })
		return data
	}

	const getSchema = formSchema(isNational)

	const {
		register,
		handleSubmit,
		formState: { errors, isDirty, isValid },
		watch,
		setValue,
		setError,
		getValues,
		clearErrors,
		resetField,
		reset
	} = useForm<IFormData>({
		resolver: yupResolver(getSchema),
		mode: 'onChange',
		defaultValues: {
			hasPassword: true,
		},

		delayError: 1000 * 1 //1 seconds
	})

	useFormPersist('registerForm', {
		watch,
		setValue,
		storage: window.sessionStorage
	})

	const { mutateAsync: sendSubscription, isLoading } = useSendSubscription()

	function openModal(message: string) {
		setModalMessage(message);
		resetVerifyCoupon();
		setModalIsOpen(true);
	}

	function closeModal() {
		setModalIsOpen(false);
	}

	function openPopup() {
		setPopupIsOpen(true);
	}

	function closePopup() {
		setPopupIsOpen(false);
	}

	async function verifyCoupon(coupon: string | null) {
		if (coupon) {
			verifyCouponResponse = await mutateVerifyCoupon({
				coupon: coupon
			})

			let now = new Date();
			let end_at = new Date(verifyCouponResponse.data.end_at);
			let expiration_message_until = verifyCouponResponse.data.show_expiration_message_until;

			if (end_at < now && (!expiration_message_until || new Date(expiration_message_until) > now)) {
				if (verifyCouponResponse.data.expiration_message) {
					openModal(verifyCouponResponse.data.expiration_message);
				}
			}
		}
	}

	async function checkCupom(voucher: string, payment: string, installments: string|null) {
		clearErrors('voucher')

		const cupom = voucher
		let attributeInstallments = installments ?? getValues('installments')
		attributeInstallments = attributeInstallments !== undefined ? attributeInstallments : "1"

		if (cupom) {
			if(!subscriptionSelected?.vindi_plan_id || subscriptionSelected?.vindi_plan_id == 0) return;
			const response = await mutateCupom({
				voucher: cupom,
				vindi_plan_id: subscriptionSelected?.vindi_plan_id ?? 0,
				installments: attributeInstallments,
				payment: payment === 'creditCard' ? 'credit_card' : payment === 'pix' ? 'pix' : 'all'
			})

			if (!response.data.valid) {
				setIsCupomValid(false)
				setError('voucher', { message: 'Cupom não é válido' })
			} else {
				setIsCupomValid(true)
			}
		}
	}

	function submitOnBlur() {
		const data = getValues()

		const product = subscriptionSelected?.mrc_product;

		if (data.email) {
			preRegister({
				email: data.email,
				name: data.name,
				telefone: data.phone,
				produto: product ?? '',
				cep: data.zipcode,
				numero: data.number,
				utm_term: urlParams.get('utm_term'),
				utm_campaign: urlParams.get('utm_campaign'),
				utm_content: urlParams.get('utm_content'),
				utm_medium: urlParams.get('utm_medium'),
				utm_sale: urlParams.get('utm_sale'),
				utm_source: urlParams.get('utm_source')
			})
		}

		//HUBSPOT
		saveHubspotBehavioralProps(data)
	}

	const onSubmit = handleSubmit(async (data) => {
	
		// return

		if (!data) return

		const clientInfo = await fetch("https://cdn.oantagonista.com/cdn-cgi/trace");
		const text = await clientInfo.text();
		const lines = text.trim()?.split("\n");

		const trace: ClientIpsInfoRequest = lines.reduce((acc, curr) => {
			const [key, value] = curr?.split("=");
			acc[key] = value;
			return acc;
		}, {} as ClientIpsInfoRequest)

		// console.log(subscriptionSelected)

		const response = await sendSubscription({
			...data,
			country: isNational ? 'BR' : 'EX',
			vindi_plan_id: subscriptionSelected?.vindi_plan_id,
			client_ips_infos: { ...trace }
		})


		const toast = cogoToast.error(
			response.data.message || 'Error ao realizar compra',
			{
				...cogoDefaultOptions,
				hideAfter: 0,
				onClick: () => {
					if (toast?.hide)
						toast.hide();
				}
			}
		);

		// const { value, symbol } = getPaymentValue(allExistingActiveSubscriptions, isNational)

		// ReactPixel.track('Purchase', { value, currency: symbol })

		if (data.payment === 'pix') {
			return navigate(
				routesEnum.PAYMENT_PIX + '/' + response.data.assinatura_id+ '?plano='+urlParams.get("plano"),
				{
					state: {
						...response.data
					}
				}
			)
		}

		if (data.payment === 'creditCard') {
			return navigate(routesEnum.PAYMENT_CREDIT, {
				state: {
					...response.data
				}
			})
		}
	})

	const [uf, installments] = watch(['state', 'installments'])

	async function getCitiesAndavailableStates() {

		if (!isNational) return

		if (!availableStates.length) {
			const availableStates = await getState()
			setavailableStates(availableStates)
		}

		if (!!uf) {
			const availableCities = await getCities(uf)
			setAvailableCities(availableCities)
		}
	}

	useEffect(() => {
		getCitiesAndavailableStates()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uf])

	//facebook pixel
	useEffect(() => {
		// ReactPixel.track('AddToCart')
	}, [])

	//facebook pixel
	useEffect(() => {
		// ReactPixel.track('AddPaymentInfo')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [paymentMethods])

	const creditCardInfos: ICreditCardInfos = {
		card_profile: userDetails?.perfil_cartao,
		card_profile_last_four_digits: userDetails?.perfil_quatro_ultimos,
		payment_profile: userDetails?.perfil_id
	}

	const modalStyles = {
		content: {
			minHeight: '100px',
			color: '#FFF',
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			background: 'linear-gradient(180deg, BLACK -31%,#24A4C4 78%)',
		},
	};

	const popupStyles = {
		content: {
			minHeight: '100px',
			color: '#FFF',
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			background: '#EAEBED',
			paddingRight: '0px',
			paddingLeft: '0px',
		},
	};

	const closeButtonStyles = {
		color: '#282828',
		position: 'absolute',
		top: '5px',
		right: '10px',
		border: 'none',
		background: 'transparent',
		fontSize: '24px',
		cursor: 'pointer',
	};

	const clickHereButtonStyles = {
		color: '#282828',
		textDecoration: 'none',
		maxWidth: '100%',
		height: 'auto',
	};

	const containerStyle = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	};

	const viewProps: IViewProps = {
		onSubmit,
		errors,
		register,
		watch,
		checkCupom,
		cupomCheckResponse,
		verifyCoupon,
		couponVerifyResponse,
		submitOnBlur,
		userDetails,
		isDirty,
		isValid,
		creditCardInfos,
		resetCupom,
		resetVerifyCoupon,
		availableStates,
		availableCities,
		isLoading,
		setValue,
		resetField,
		setError,
		checkUser,
		subscriptionSelected,
		setSubscriptionSelected,
		clearErrors
	}

	const url = `https://registre.oantagonista.com.br/?plano=combo&tipo=anual&cupom=OASITE10`;

	return (
		<>
			{showPopup && (
				<Modal
					isOpen={popupIsOpen}
					onRequestClose={closePopup}
					style={popupStyles}
				>
					<button style={closeButtonStyles as React.CSSProperties} onClick={closePopup}>×</button>
					<br></br>
					<a href={url}>
					<img src={banner}/></a>
					<div style={containerStyle as React.CSSProperties}>
						<br></br><a style={clickHereButtonStyles as React.CSSProperties} className="centered-link" href="https://registre.oantagonista.com.br/?plano=combo&tipo=anual&cupom=OASITE10"><h3>CLIQUE AQUI</h3></a>
					</div>
				</Modal>
			)}
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={modalStyles}
			>
				<button style={closeButtonStyles  as React.CSSProperties} onClick={closeModal}>×</button>
				<br></br><h2>{modalMessage}</h2>
			</Modal>
			{createElement(HomeView, viewProps)}
		</>
	);
}

export { HomeContainer }
